import LegalLayout from './LegalLayout';

const H = ({ children }) => (
  <h2 className="text-xl font-heading text-foreground mt-8 mb-2">{children}</h2>
);

const Privacy = () => (
  <LegalLayout
    title="Privacy Policy"
    description="How Rudragarh Resort collects, uses, and protects your personal information when you book or browse our website."
    path="/privacy"
    updated="July 2026"
  >
    <p>
      This Privacy Policy explains how Rudragarh Resort ("we", "us") collects, uses, and
      protects your personal information when you use our website or make a booking. We are
      committed to handling your data responsibly and in accordance with applicable Indian
      law.
    </p>

    <H>Information We Collect</H>
    <ul className="list-disc pl-6 space-y-1">
      <li><b>Booking details</b> — your name, email address, phone number, stay dates, room preferences, number of guests, and any special requests you share.</li>
      <li><b>Payment information</b> — when you pay online, payment is processed by our payment partner. We receive confirmation of payment but do <b>not</b> collect or store your card or bank account numbers.</li>
      <li><b>Usage data</b> — basic analytics such as pages visited and device/browser type, collected via cookies and Google Analytics to help us improve the site.</li>
    </ul>

    <H>How We Use Your Information</H>
    <ul className="list-disc pl-6 space-y-1">
      <li>To process, confirm, and manage your booking and stay.</li>
      <li>To communicate with you about your reservation (by email, phone, or WhatsApp).</li>
      <li>To manage room availability across our booking channels.</li>
      <li>To improve our website and services, and to meet legal or tax obligations.</li>
    </ul>

    <H>Sharing Your Information</H>
    <p>
      We share your information only as needed to provide our services — for example with
      our payment gateway (to process payments), our email provider (to send booking
      confirmations), and our channel-manager/booking system (to manage availability). We
      do not sell your personal information. We may disclose information where required by
      law or to protect our rights.
    </p>

    <H>Cookies &amp; Analytics</H>
    <p>
      We use cookies and Google Analytics to understand how visitors use the site. You can
      control or disable cookies through your browser settings; some site features may not
      function as intended if cookies are disabled.
    </p>

    <H>Data Retention</H>
    <p>
      We retain booking and transaction records for as long as necessary to provide our
      services and to comply with legal, accounting, and tax requirements, after which they
      are securely deleted or anonymised.
    </p>

    <H>Security</H>
    <p>
      We take reasonable technical and organisational measures to protect your information.
      Online payments are handled by a PCI-DSS-compliant payment partner over encrypted
      connections. No method of transmission over the internet is completely secure, and we
      cannot guarantee absolute security.
    </p>

    <H>Your Rights</H>
    <p>
      You may request access to, correction of, or deletion of your personal information,
      subject to our legal retention obligations. To make a request, contact us using the
      details below.
    </p>

    <H>Contact</H>
    <p>
      For any privacy questions or requests: Rudragarh Resort, Village Damodra, Sam Road,
      near Jaisalmer, Rajasthan 345001, India. Email:{' '}
      <a href="mailto:info@rudragarh.com" className="text-gold-500 underline">info@rudragarh.com</a>,
      Phone: <a href="tel:+919649611111" className="text-gold-500 underline">+91 96496 11111</a>.
    </p>
  </LegalLayout>
);

export default Privacy;
